import React from 'react';
import styled from 'styled-components';
import { IconProps } from './types';

const ColorPickerIcon = (props: IconProps): JSX.Element => (
  // allow prop spreading for svg icon
  // eslint-disable-next-line
  <svg {...props} viewBox="0 0 32 32">
    <defs>
      <path id="a" d="M0 .093h9.4v8.279H0z" />
      <path id="c" d="M.015.096h9.402v8.268H.015z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2 16.734)">
        <mask id="b" fill="#fff">
          <use xlinkHref="#a" />
        </mask>
        <path
          fill="#4464EA"
          d="M4.316.103c1.213 0 2.427.012 3.64-.007.386-.005.62.058.697.504.09.53.308 1.036.62 1.48.191.271.168.446-.071.683a661.8 661.8 0 0 0-5.433 5.433c-.274.277-.413.202-.62-.053C1.369 5.96.334 3.47.01.673-.04.23.084.083.54.093c1.258.029 2.517.01 3.775.01"
          mask="url(#b)"
        />
      </g>
      <g transform="translate(20.521 16.734)">
        <mask id="d" fill="#fff">
          <use xlinkHref="#c" />
        </mask>
        <path
          fill="#FBC41D"
          d="M9.39.583c-.301 2.83-1.34 5.344-3.127 7.553-.256.317-.406.285-.672.016A572.273 572.273 0 0 0 .25 2.815c-.28-.276-.31-.477-.091-.797C.465 1.57.663 1.06.766.53.83.196.97.094 1.303.096c2.54.012 5.079.012 7.618 0 .37-.001.572.084.47.487"
          mask="url(#d)"
        />
      </g>
      <path
        fill="#AE40C9"
        d="M15.087 6.343c0 1.235-.01 2.471.007 3.707.004.346-.076.52-.45.593a3.999 3.999 0 0 0-1.545.646c-.291.206-.472.113-.69-.107-1.79-1.8-3.582-3.6-5.39-5.382-.294-.29-.242-.437.049-.67 2.215-1.776 4.73-2.81 7.551-3.123.442-.048.476.15.473.494-.012 1.28-.005 2.56-.005 3.842"
      />
      <path
        fill="#EF3F3F"
        d="M16.848 6.229c0-1.235.01-2.47-.007-3.705-.005-.386.042-.55.513-.499 2.777.302 5.243 1.324 7.431 3.055.384.304.373.472.032.806a456.97 456.97 0 0 0-5.244 5.237c-.282.285-.5.37-.85.112-.38-.28-.827-.488-1.293-.544-.553-.065-.598-.373-.59-.825.022-1.212.008-2.425.008-3.637"
      />
      <path
        fill="#38B14E"
        d="M15.085 25.646c0 1.257-.018 2.516.01 3.773.01.438-.135.533-.543.488-2.825-.306-5.33-1.36-7.53-3.153-.243-.198-.28-.332-.035-.574a764.318 764.318 0 0 0 5.48-5.48c.22-.223.374-.233.621-.06.388.273.821.516 1.283.573.657.081.75.421.727.996-.044 1.144-.013 2.29-.013 3.437"
      />
      <path
        fill="#75B818"
        d="M16.847 25.603c0-1.234.018-2.47-.01-3.704-.009-.394.115-.558.496-.627a3.71 3.71 0 0 0 1.48-.622c.284-.2.45-.143.676.085a546.17 546.17 0 0 0 5.388 5.376c.327.321.243.47-.06.714-2.138 1.717-4.566 2.724-7.284 3.074-.585.075-.719-.096-.699-.659.043-1.21.013-2.424.013-3.637"
      />
      <path
        fill="#7149E7"
        d="M6.249 15.076c-1.236 0-2.473-.02-3.708.01-.462.01-.579-.148-.528-.582.329-2.796 1.37-5.284 3.147-7.47.246-.301.398-.233.631.003a723.537 723.537 0 0 0 5.388 5.385c.265.262.257.444.07.738-.202.32-.414.674-.469 1.036-.115.76-.5.945-1.23.898-1.096-.07-2.2-.018-3.301-.018"
      />
      <path
        fill="#F49F02"
        d="M25.615 15.078c-1.237 0-2.474-.014-3.71.008-.377.006-.56-.083-.633-.488a3.73 3.73 0 0 0-.625-1.48c-.198-.282-.146-.452.087-.682 1.805-1.788 3.6-3.585 5.39-5.388.229-.23.376-.322.63-.013 1.817 2.22 2.845 4.763 3.167 7.606.045.396-.14.443-.461.44-1.282-.01-2.563-.003-3.845-.003"
      />
    </g>
  </svg>
);

const StyledColorPickerIcon = styled(ColorPickerIcon)`
  width: ${({ size = '1rem' }) => size};
  height: ${({ size = '1rem' }) => size};
  vertical-align: middle;
`;
export default StyledColorPickerIcon;
